import styled, { css } from 'styled-components';
import { hideScrollbar } from '@stylesheets/helpers';
import { duration } from '@stylesheets/motion';
import { APPS_PHONE_MEDIA } from '../../pages/Apps/apps.constants';
import { GALLERY_Z_INDEX } from './AppsFooter.constants';

const gallery = css`
  position: absolute;
  inset: 0;
  z-index: ${GALLERY_Z_INDEX};
  padding-top: 16px;
  border-top: none;
`;

export const Root = styled.section<{ $open: boolean; $expanded: boolean }>`
  flex: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  padding: 6px 28px ${({ $open }) => ($open ? '16px' : '6px')};

  ${({ theme: { colors } }) => css`
    border-top: 1px solid ${colors.shellDivider};
    background: ${colors.surface};
    color: ${colors.onSurface};
  `}

  ${({ $expanded }) => $expanded && gallery}

  ${APPS_PHONE_MEDIA} {
    padding-inline: 12px;
    padding-bottom: max(${({ $open }) => ($open ? '12px' : '4px')}, env(safe-area-inset-bottom));
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  min-height: 44px;
`;

export const TitleButton = styled.button<{ $active: boolean }>`
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 6px 8px;
  border: none;
  background: transparent;
  font: inherit;
  font-size: 17px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  cursor: pointer;

  &:first-child {
    margin-left: -8px;
  }

  ${({ $active, theme: { colors, borderRadius } }) => css`
    border-radius: ${borderRadius.small};
    color: ${$active ? colors.onSurface : colors.onSurfaceVariant};
    transition: background-color ${duration.fast} ease;

    &:hover {
      color: ${colors.onSurface};
      background: ${colors.surfaceContainerHigh};
    }

    &:focus-visible {
      outline: 2px solid ${colors.primary};
      outline-offset: 2px;
    }
  `}

  ${APPS_PHONE_MEDIA} {
    font-size: 15px;
  }
`;

export const TabsSlot = styled.div`
  min-width: 0;
  overflow-x: auto;
  ${hideScrollbar}
`;

export const Separator = styled.span`
  flex: none;
  width: 1px;
  height: 22px;
  background: ${({ theme: { colors } }) => colors.shellDivider};
`;

export const Actions = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
`;

export const Body = styled.div<{ $expanded: boolean }>`
  min-width: 0;
  ${({ $expanded }) =>
    $expanded &&
    css`
      flex: 1;
      min-height: 0;
      overflow-y: auto;
    `}
`;

export const Note = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 72px;
  font-size: 14px;
  color: ${({ theme: { colors } }) => colors.onSurfaceVariant};
`;
